import { FC } from "react"
import { Provider } from "react-redux"
import { BrowserRouter, Route, Routes } from "react-router-dom"
import { ToastContainer } from "react-toastify"
import { useAppInit } from "@/hooks/useAppInit"
import { useTokenRefresh } from "@/hooks/useTokenRefresh"
import { Modals, ModalsProvider } from "@/modals"
import { PrivacyPolicy } from "@/pages/PrivacyPolicy"
import { TermsOfUse } from "@/pages/TermsOfUse"
import { ErrorBoundary } from "@/providers/ErrorBoundary"
import { WebAppViewportProvider } from "@/providers/WebAppViewport"
import { WithGsap } from "@/providers/WithGsap"
import { AppVersion } from "@/ui/AppVersion"
import { DevFloatingButton } from "@/ui/DevFloatingButton"
import { NotALabrUser } from "@/ui/NotALabrUser"
import { SvgGlobal } from "@/ui/SvgGlobal"
import { UnderMaintenance } from "@/ui/UnderMaintenance"
import { Router } from "./pages"
import { store } from "./store"

const AppShell: FC = () => {
  const { isInit } = useAppInit()

  useTokenRefresh()

  if (!isInit) return null

  return (
    <>
      <AppVersion />
      <WithGsap>
        <Provider store={store}>
          <ModalsProvider>
            <ErrorBoundary>
              <WebAppViewportProvider>
                <Router />
                <Modals />
                <ToastContainer
                  position="bottom-right"
                  autoClose={3000}
                  hideProgressBar={false}
                  closeOnClick
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                  theme="dark"
                  stacked
                />
                <UnderMaintenance />
                <NotALabrUser />
                <SvgGlobal />
                {import.meta.env.VITE_NODE_ENV !== "production" && (
                  <DevFloatingButton />
                )}
              </WebAppViewportProvider>
            </ErrorBoundary>
          </ModalsProvider>
        </Provider>
      </WithGsap>
    </>
  )
}

export const App: FC = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms-of-use" element={<TermsOfUse />} />
      <Route path="*" element={<AppShell />} />
    </Routes>
  </BrowserRouter>
)
